import React from "react";
import { NavHorizontal, NavItem } from "@flixbus/honeycomb-react";
import type { CalculationCategoryTabsProps } from "./CalculationCategoryTabs.types";
import styles from "./CalculationCategoryTabs.module.scss";

const CalculationCategoryTabs: React.FC<CalculationCategoryTabsProps> = ({
  categoryGroups,
  activeCategoryId,
  activeSubcategoryId,
  onCategoryChange,
  onSubcategoryChange,
}) => {
  const activeGroup = categoryGroups.find((g) => g.id === activeCategoryId);

  return (
    <div className={styles.tabsContainer}>
      <NavHorizontal aria-label="Cost categories">
        {categoryGroups.map((group) => (
          <NavItem
            key={group.id}
            onClick={() => onCategoryChange(group.id)}
            active={group.id === activeCategoryId}
          >
            {group.name}
          </NavItem>
        ))}
      </NavHorizontal>
      {activeGroup && activeGroup.subcategories.length > 0 && (
        <NavHorizontal aria-label="Subcategories" wrapper>
          {activeGroup.subcategories.map((sub) => (
            <NavItem
              key={sub.id}
              onClick={() => onSubcategoryChange(sub.id)}
              active={sub.id === activeSubcategoryId}
            >
              {sub.name}
            </NavItem>
          ))}
        </NavHorizontal>
      )}
    </div>
  );
};

export default React.memo(CalculationCategoryTabs);
